export default function validation(response, messages) {
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('TIME_TABLE_BILL_SHOULD_BE_SAVED') === 0 && !messages.find((message) => { return message.message === 'listeEcheancesAPayer.popUpCreationLotPaiement.errors.billBadState'; })) {
      messages.push({
        message: 'listeEcheancesAPayer.popUpCreationLotPaiement.errors.billBadState',
      });
    }
    if (message.indexOf('PAYMENT_SHOULD_BE_POSITIVE') === 0 && !messages.find((message) => { return message.message === 'listeEcheancesAPayer.popUpCreationLotPaiement.errors.montantShouldBePositive'; })) {
      messages.push({
        message: 'listeEcheancesAPayer.popUpCreationLotPaiement.errors.montantShouldBePositive',
      });
    }
    if (message.indexOf('SHOULD_HAVE_PURCHASE_ACTION') === 0 && !messages.find((message) => { return message.message === 'listeEcheancesAPayer.popUpCreationLotPaiement.errors.modeReglementAchat'; })) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'listeEcheancesAPayer.popUpCreationLotPaiement.errors.modeReglementAchat',
        parametres: { modeReglement: elements[1] },
      });
    }
    if (message.indexOf('PAYER_OF_ORDER_HAS_NO_PAYMENT_TYPE') === 0 && !messages.find((message) => { return message.message === 'listeEcheancesAPayer.popUpCreationLotPaiement.errors.shouldHaveModeReglement'; })) {
      messages.push({
        message: 'listeEcheancesAPayer.popUpCreationLotPaiement.errors.shouldHaveModeReglement',
      });
    }
    if (message.indexOf('ONLY_ONE_CONFIGURATION_PER_PAYMENT_TYPE') === 0 && !messages.find((message) => { return message.message === 'listeEcheancesAPayer.popUpCreationLotPaiement.errors.oneConfigurationPerPaymentType'; })) {
      messages.push({
        message: 'listeEcheancesAPayer.popUpCreationLotPaiement.errors.oneConfigurationPerPaymentType',
      });
    }
    if (message.indexOf('PAYMENT_PLAN_OF_BILL_CONTAINS_PAYMENT_TYPE_NOT_CONFIGURED') === 0 && !messages.find((message) => { return message.message === 'listeEcheancesAPayer.popUpCreationLotPaiement.errors.PaymentPlanOfBillContainsPaymentTypeNotConfigured'; })) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'listeEcheancesAPayer.popUpCreationLotPaiement.errors.PaymentPlanOfBillContainsPaymentTypeNotConfigured',
        parametres: { codeFacture: elements[1], modeReglement: elements[2] },
      });
    }
    if (message.indexOf('PAYMENT_TYPE_OF_PAYER_NOT_CONFIGURED') === 0 && !messages.find((message) => { return message.message === 'listeEcheancesAPayer.popUpCreationLotPaiement.errors.PaymentTypeOfPayerNotConfigured'; })) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'listeEcheancesAPayer.popUpCreationLotPaiement.errors.PaymentTypeOfPayerNotConfigured',
        parametres: { codeCommande: elements[1], modeReglement: elements[2] },
      });
    }
    if (message.indexOf('SAVED_BILLED_STATE_REQUIRED') === 0 && !messages.find((message) => { return message.message === 'listeEcheancesAPayer.popUpCreationLotPaiement.errors.savedBilledStateRequired'; })) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'listeEcheancesAPayer.popUpCreationLotPaiement.errors.savedBilledStateRequired',
        parametres: { codeCommande: elements[1] },
      });
    }
    if (message.indexOf('DELAI_REGLEMENT_WITH_NOMBRE_JOUR_DECALAGE_AND_FIN_DE_MOIS_NOT_FOUND') === 0 && !messages.find((message) => { return message.message === 'listeEcheancesAPayer.popUpCreationLotPaiement.errors.delaiReglementWithNombreJourDecalageAndFinDeMoisNotFound'; })) {
      messages.push({
        message: 'listeEcheancesAPayer.popUpCreationLotPaiement.errors.delaiReglementWithNombreJourDecalageAndFinDeMoisNotFound',
      });
    }
  });
}
